import { ReactNode } from 'react';
import { truncateStyle } from './styles.css';

interface TruncateProps {
  children: ReactNode | string;
  maxWidth: number;
}

/**
 * For truncating a text node to a max width
 *
 * Overflow is represented with elipses
 * */
export const Truncate = ({ children, maxWidth }: TruncateProps) => (
  <div
    className={truncateStyle}
    style={{
      maxWidth: `${maxWidth}px`,
    }}
  >
    {children}
  </div>
);
